module.exports = "/_next/static/resources/art1-38e695f30878b3cfe31ba7f2062f4571.webp";